import React, { FunctionComponent } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';
import { useShareContext } from '../../context/ShareContext';

export type WhatsAppShareProps = WithTrack & {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const WhatsAppShare: FunctionComponent<WhatsAppShareProps> = ({
  className,
  track,
  trackingData,
  onClick,
}) => {
  const { shareItems } = useShareContext();

  const trackClick = () => {
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'whatsapp',
      ...trackingData,
    });
    if (onClick) {
      onClick();
    }
  };

  return (
    <a
      data-qa="whatsapp-btn"
      href={`https://wa.me/?text=${encodeURIComponent(
        shareItems.whatsApp.message,
      )}`}
      className={`jg-btn jg-btn--whatsapp ${className}`}
      onClick={trackClick}
    >
      <span className="jg-sr-only">Share by </span>
      WhatsApp
    </a>
  );
};

export default withTrack(WhatsAppShare);
